import React, { Component } from 'react';
import Modal from 'components/Modal';
import isEmpty from 'lodash/isEmpty';
import reduce from 'lodash/reduce';
import features from 'lib/common/features';
import PropTypes from 'prop-types';

class AdaAttestation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validationError: false
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.reRender = this.reRender.bind(this);
  }
  handleClose() {
    this.props.handleDeselection();
  }
  getAdaChoices(adaOptionEls) {
    let adaChoices = reduce(
      adaOptionEls,
      (acc, item) => {
        if (item.type === 'checkbox' && item.checked) {
          acc[item.value] = 'Y';
        }
        if (item.type === 'radio' && item.checked) {
          acc[item.value] = 'Y';
        }
        return acc;
      },
      {}
    );

    return isEmpty(adaChoices) ? null : adaChoices;
  }
  handleSubmit(e) {
    e.preventDefault();

    let adaChoices = JSON.stringify(this.getAdaChoices(e.target.elements));

    let regex = /([{}])/g;

    adaChoices = adaChoices.replace(regex, '');

    adaChoices = adaChoices.replace(',', '\r\n');

    if (adaChoices !== 'null') {
      this.props.handleSelection(adaChoices);
    } else {
      this.setState({
        validationError: 'You must select at least one option'
      });
    }
  }

  renderRequestOption(option) {
    if (option.type && option.type == 'radio') {
      let enabled = true;
      if (option.condition) {
        let checkedValue = '';
        let conditionElements = document.getElementsByName(
          option.condition.mapField
        );
        for (let conditionElement of conditionElements) {
          if (conditionElement.checked) {
            checkedValue = conditionElement.value;
          }
        }
        enabled = checkedValue == option.condition.equals;
      }

      if (enabled) {
        return (
          <li
            className="field-optionlist__item field-optionlist__radio"
            key={option.mapField}
          >
            <label className="field-option">{option.title}</label>
            {option.options.map(radio => {
              return (
                <div key={`${option.mapField}-${radio.value}`}>
                  <input
                    className="field-option__input"
                    type="radio"
                    name={option.mapField}
                    value={radio.value}
                    onChange={this.reRender}
                    onClick={this.reRender}
                    id={`${option.mapField}-${radio.value}`}
                  />
                  <label
                    className="field-option__label"
                    htmlFor={`${option.mapField}-${radio.value}`}
                    onClick={this.reRender}
                  >
                    {radio.text}
                  </label>
                </div>
              );
            })}
          </li>
        );
      }
    } else {
      let enabled = true;
      if (option.condition) {
        let checkedValue = '';
        let conditionElements = document.getElementsByName(
          option.condition.mapField
        );
        for (let conditionElement of conditionElements) {
          if (conditionElement.checked) {
            checkedValue = conditionElement.value;
          }
        }
        enabled = checkedValue == option.condition.equals;
      }
      if (enabled) {
        return (
          <li className="field-optionlist__item" key={option.option}>
            <label className="field-option">
              <input
                className="field-option__input"
                name={option.mapField}
                type="checkbox"
                value={option.option}
                onChange={this.reRender}
                onClick={this.reRender}
              />
              <label
                className="field-option__label"
                htmlFor={option.mapField}
                onClick={this.reRender}
              >
                {option.option}
              </label>
            </label>
          </li>
        );
      }
    }
  }

  reRender() {
    this.setState({
      ...this.state
    });
  }

  render() {
    return (
      <Modal title="Wheelchair Accessible Seating" onClose={this.handleClose}>
        <form className="ada-form" action="" onSubmit={this.handleSubmit}>
          <div className="ada-form__details">
            <h3 className="ada-form__title">
              You have selected accessible seating areas that are solely for
              individuals who require the features of these seats and their
              companions.
            </h3>

            <div
              className="ada-form__smallprint"
              dangerouslySetInnerHTML={{
                __html: features.getOption(
                  'adaAttestation',
                  'attestationSmallPrint'
                )
              }}
            />
          </div>

          <div className="ada-form__fields">
            <fieldset className="form-fieldset">
              <legend className="form-fieldset__legend">
                Please review the list below and select the applicable option
                for your booking.
                <br />
                <i>
                  We recommend that patrons requiring assistance with their
                  access requirements when attending performances at Arts Centre
                  Melbourne have a companion accompany them. While ACM does have
                  team members on hand to assist we cannot always provide
                  individual attention.
                </i>
              </legend>

              {this.state.validationError && (
                <p className="field-error">{this.state.validationError}</p>
              )}

              <div className="field-group">
                <ol className="field-optionlist field-optionlist--columns">
                  {this.props.specialRequestOptions.map(option => {
                    return this.renderRequestOption(option);
                  })}
                </ol>
              </div>

              <div className="form-actions">
                <input
                  type="reset"
                  className="syos-button syos-button--secondary"
                  onClick={this.handleClose}
                  value="Close"
                />
                <input type="submit" className="syos-button" value="Continue" />
              </div>
            </fieldset>
          </div>
        </form>
      </Modal>
    );
  }
}

AdaAttestation.propTypes = {
  handleSelection: PropTypes.func.isRequired,
  handleDeselection: PropTypes.func.isRequired,
  specialRequestOptions: PropTypes.array.isRequired
};

export default AdaAttestation;



// WEBPACK FOOTER //
// ./src/javascripts/components/AdaAttestation.js